<template>
  <div class="system-manage">
    <h1 class="system-manage__title">用户管理</h1>
    <div class="system-manage__card">
      <el-form :inline="true" :model="query" size="small" class="system-manage__filters" @submit.native.prevent="search">
        <el-form-item label="用户姓名"><el-input v-model.trim="query.realName" placeholder="请输入用户姓名" clearable @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="用户账号"><el-input v-model.trim="query.username" placeholder="请输入用户账号" clearable @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="手机号"><el-input v-model.trim="query.mobile" placeholder="请输入手机号" clearable @keyup.enter.native="search" /></el-form-item>
        <el-form-item label="状态"><el-select v-model="query.status" placeholder="全部" clearable><el-option label="启用" :value="1" /><el-option label="禁用" :value="0" /></el-select></el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="search">查询</el-button><el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button></el-form-item>
      </el-form>
    </div>
    <div class="system-manage__card">
      <div class="system-manage__toolbar">
        <el-button v-if="canCreateUser" type="primary" size="small" icon="el-icon-plus" @click="openCreate">新增</el-button>
        <el-button v-if="can('system:user:status')" type="danger" plain size="small" icon="el-icon-lock" :disabled="!canBatchStatus(0)" :loading="operating" @click="changeStatus(selection, 0)">禁用</el-button>
        <el-button v-if="can('system:user:status')" type="success" size="small" icon="el-icon-unlock" :disabled="!canBatchStatus(1)" :loading="operating" @click="changeStatus(selection, 1)">启用</el-button>
        <el-button v-if="can('system:user:delete')" type="danger" size="small" icon="el-icon-delete" :disabled="!selection.length || selection.some(isProtected)" :loading="operating" @click="removeUsers(selection)">删除</el-button>
        <el-button v-if="can('system:user:export')" type="primary" plain size="small" icon="el-icon-download" :loading="exporting" @click="exportUsers">导出</el-button>
        <el-button size="small" :icon="showMobile ? 'el-icon-view' : 'el-icon-lock'" @click="showMobile = !showMobile">{{ showMobile ? '隐藏手机号' : '显示手机号' }}</el-button>
      </div>
      <el-table v-loading="loading" :data="list" row-key="id" @selection-change="selection = $event">
        <el-table-column type="selection" width="48" align="center" />
        <el-table-column label="操作" width="210" align="center" fixed="left">
          <template slot-scope="{ row }"><div class="system-manage__actions">
            <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
            <el-button v-if="can('system:user:edit')" type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-dropdown v-if="hasRowActions" trigger="click" @command="handleCommand($event, row)">
              <el-button type="text" size="small">更多<i class="el-icon-arrow-down el-icon--right" /></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="can('system:user:status')" command="status" :disabled="isProtected(row)">{{ row.status === 1 ? '禁用账号' : '启用账号' }}</el-dropdown-item>
                <el-dropdown-item v-if="can('system:user:assign')" command="roles" :disabled="isProtected(row)">分配角色</el-dropdown-item>
                <el-dropdown-item v-if="can('system:user:reset')" command="password">重置密码</el-dropdown-item>
                <el-dropdown-item v-if="can('system:user:token')" command="token">API Token</el-dropdown-item>
                <el-dropdown-item v-if="can('system:user:delete')" command="delete" :disabled="isProtected(row)">删除账号</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div></template>
        </el-table-column>
        <el-table-column prop="realName" label="用户姓名" min-width="110" show-overflow-tooltip><template slot-scope="{ row }">{{ row.realName || '-' }}</template></el-table-column>
        <el-table-column prop="username" label="用户账号" min-width="140" show-overflow-tooltip />
        <el-table-column prop="mobile" label="手机号" min-width="125"><template slot-scope="{ row }">{{ mobileLabel(row.mobile) }}</template></el-table-column>
        <el-table-column label="账号类型" width="110"><template slot-scope="{ row }">{{ row.superAdmin ? '超级管理员' : row.accountType === 'SUB' ? '子账号' : '主账号' }}</template></el-table-column>
        <el-table-column label="角色" min-width="170" show-overflow-tooltip><template slot-scope="{ row }">{{ (row.roleNames || []).join('、') || '-' }}</template></el-table-column>
        <el-table-column label="状态" width="90" align="center"><template slot-scope="{ row }"><el-tag :type="row.status === 1 ? 'success' : 'info'" size="small">{{ row.status === 1 ? '启用' : '禁用' }}</el-tag></template></el-table-column>
        <el-table-column v-if="can('system:user:token')" label="API Token" min-width="145" align="center"><template slot-scope="{ row }"><el-tag v-if="tokenStatus[row.id] && tokenStatus[row.id].active" type="success" size="small">有效{{ ttlLabel(tokenStatus[row.id].expiresInSeconds) }}</el-tag><span v-else>{{ tokenStatus[row.id] && tokenStatus[row.id].failed ? '读取失败' : tokenStatus[row.id] ? '未登录或已过期' : '读取中' }}</span></template></el-table-column>
        <el-table-column label="创建时间" min-width="165"><template slot-scope="{ row }">{{ formatDate(row.createTime) }}</template></el-table-column>
      </el-table>
      <div class="system-manage__pagination"><el-pagination :current-page="pageNum" :page-size="pageSize" :total="total" :page-sizes="[10, 20, 50]" layout="total, sizes, prev, pager, next, jumper" background @current-change="changePage" @size-change="changeSize" /></div>
    </div>

    <el-dialog :title="editingId ? '编辑用户' : '新增用户'" :visible.sync="dialogVisible" width="650px" :close-on-click-modal="false">
      <el-form ref="userForm" :model="form" :rules="rules" label-width="95px" class="system-manage__form">
        <el-row :gutter="20">
          <el-col :span="12"><el-form-item label="用户姓名" prop="realName"><el-input v-model.trim="form.realName" maxlength="64" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="用户账号" prop="username"><el-input v-model.trim="form.username" :disabled="!!editingId" maxlength="64" autocomplete="off" /></el-form-item></el-col>
        </el-row>
        <el-form-item v-if="!editingId" label="登录密码" prop="password"><el-input v-model="form.password" type="password" show-password maxlength="72" autocomplete="new-password" placeholder="请输入8至72字节密码" /></el-form-item>
        <el-row :gutter="20">
          <el-col :span="12"><el-form-item label="手机号" prop="mobile"><el-input v-model.trim="form.mobile" maxlength="32" /></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="邮箱" prop="email"><el-input v-model.trim="form.email" maxlength="128" /></el-form-item></el-col>
        </el-row>
        <el-form-item v-if="currentUser.superAdmin" label="账号类型"><el-radio-group v-model="form.accountType" :disabled="!!editingId || !currentUser.superAdmin" @change="changeAccountType"><el-radio label="MAIN">主账号</el-radio><el-radio label="SUB">子账号</el-radio></el-radio-group></el-form-item>
        <el-form-item v-if="currentUser.superAdmin && form.accountType === 'SUB'" label="所属主账号" prop="parentUserId"><el-select v-model="form.parentUserId" filterable :disabled="!!editingId || !currentUser.superAdmin" placeholder="请选择主账号" @change="loadFormRoles"><el-option v-for="user in mainAccounts" :key="user.id" :label="accountLabel(user)" :value="user.id" /></el-select></el-form-item>
        <el-form-item v-if="currentUser.superAdmin" label="超级管理员"><el-switch v-model="form.superAdmin" :disabled="form.accountType === 'SUB' || isSelf(form)" /><p class="system-manage__hint">超级管理员可管理全局账号、菜单、字典与配置。</p></el-form-item>
        <el-form-item v-if="can('system:user:assign')" label="所属角色"><el-select v-model="form.roleIds" multiple filterable :loading="rolesLoading" :disabled="rolesLoading || isSelf(form) || (!editingId && form.accountType === 'MAIN')" placeholder="请选择角色"><el-option v-for="role in roles" :key="role.id" :label="role.name + (role.status === 1 ? '' : '（禁用）')" :value="role.id" :disabled="role.status !== 1" /></el-select><p v-if="!editingId && form.accountType === 'MAIN'" class="system-manage__hint">主账号创建后，可在其账号范围内创建并分配角色。</p></el-form-item>
        <el-form-item label="备注" prop="remark"><el-input v-model.trim="form.remark" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="dialogVisible = false">取消</el-button><el-button type="primary" :loading="saving" :disabled="rolesLoading" v-permission="editingId ? 'system:user:edit' : 'system:user:add'" @click="save">确定</el-button></span>
    </el-dialog>

    <el-dialog title="用户详情" :visible.sync="detailVisible" width="620px">
      <div v-loading="detailLoading" class="system-manage__details">
        <div><label>用户姓名</label>{{ detail.realName || '-' }}</div><div><label>用户账号</label>{{ detail.username }}</div>
        <div><label>手机号</label>{{ detail.mobile || '-' }}</div><div><label>邮箱</label>{{ detail.email || '-' }}</div>
        <div><label>账号类型</label>{{ detail.superAdmin ? '超级管理员' : detail.accountType === 'SUB' ? '子账号' : '主账号' }}</div><div><label>状态</label>{{ detail.status === 1 ? '启用' : '禁用' }}</div>
        <div><label>所属主账号 ID</label>{{ detail.parentUserId || '-' }}</div><div><label>创建时间</label>{{ formatDate(detail.createTime) }}</div>
        <div class="full-width"><label>角色</label>{{ (detail.roleNames || []).join('、') || '-' }}</div><div class="full-width"><label>备注</label>{{ detail.remark || '-' }}</div>
      </div>
      <span slot="footer"><el-button @click="detailVisible = false">关闭</el-button></span>
    </el-dialog>

    <el-dialog :title="'分配角色 · ' + target.username" :visible.sync="roleVisible" width="510px" :close-on-click-modal="false">
      <el-select v-model="assignedRoleIds" multiple filterable :loading="rolesLoading" :disabled="rolesLoading" placeholder="请选择角色" style="width:100%"><el-option v-for="role in roles" :key="role.id" :value="role.id" :label="role.name + (role.status === 1 ? '' : '（禁用）')" :disabled="role.status !== 1" /></el-select>
      <p class="system-manage__hint">角色权限合并生效，禁用的角色不授予权限。</p>
      <span slot="footer"><el-button @click="roleVisible = false">取消</el-button><el-button type="primary" :loading="saving" :disabled="rolesLoading" v-permission="'system:user:assign'" @click="saveRoles">确定</el-button></span>
    </el-dialog>

    <el-dialog :title="'重置密码 · ' + target.username" :visible.sync="passwordVisible" width="460px" :close-on-click-modal="false">
      <el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="90px"><el-form-item label="新密码" prop="password"><el-input v-model="passwordForm.password" type="password" show-password maxlength="72" autocomplete="new-password" placeholder="请输入8至72字节密码" /></el-form-item></el-form>
      <p class="system-manage__hint">重置后该账号的现有登录会话与 API Token 将立即失效。</p>
      <span slot="footer"><el-button @click="passwordVisible = false">取消</el-button><el-button type="primary" :loading="saving" v-permission="'system:user:reset'" @click="savePassword">确定</el-button></span>
    </el-dialog>

    <el-dialog :title="'API Token · ' + target.username" :visible.sync="tokenVisible" width="460px">
      <p v-loading="tokenLoading">状态：{{ activeToken.failed ? '读取失败，请刷新重试' : activeToken.active ? '有效' + ttlLabel(activeToken.expiresInSeconds) : '未登录或已过期' }}</p>
      <p class="system-manage__hint">Token 由 /openapi/v1/auth/login 返回，此处仅展示状态并支持撤销。</p>
      <span slot="footer"><el-button :loading="tokenLoading" @click="refreshToken">刷新</el-button><el-button v-if="can('system:user:token')" type="danger" :disabled="!activeToken.active || tokenLoading" :loading="operating" @click="revokeToken">撤销 Token</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { saveAs } from 'file-saver'
import request from '@/utils/request'
import { getCurrentUser, hasPermission } from '@/utils/auth'

const newForm = () => ({ username: '', password: '', realName: '', mobile: '', email: '', remark: '', accountType: 'SUB', parentUserId: '', superAdmin: false, roleIds: [] })
const validatePassword = (rule, value, callback) => {
  const length = new TextEncoder().encode(value || '').length
  callback(length < 8 || length > 72 ? new Error('密码长度须为8至72字节') : undefined)
}

export default {
  name: 'InTransitUserManage',
  data() {
    return {
      currentUser: {}, query: { username: '', realName: '', mobile: '', status: '' },
      list: [], selection: [], total: 0, pageNum: 1, pageSize: 10, loading: false, requestId: 0, showMobile: false,
      saving: false, operating: false, exporting: false, dialogVisible: false, editingId: null, form: newForm(),
      roles: [], rolesLoading: false, rolesRequestId: 0, mainAccounts: [],
      detail: {}, detailVisible: false, detailLoading: false, detailRequestId: 0,
      target: {}, roleVisible: false, assignedRoleIds: [], passwordVisible: false, passwordForm: { password: '' },
      tokenStatus: {}, tokenVisible: false, tokenLoading: false,
      rules: {
        username: [{ required: true, message: '请输入用户账号', trigger: 'blur' }, { min: 2, max: 64, message: '账号长度为2至64个字符', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        password: [{ validator: validatePassword, trigger: 'blur' }],
        parentUserId: [{ required: true, message: '请选择所属主账号', trigger: 'change' }],
        email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }]
      },
      passwordRules: { password: [{ validator: validatePassword, trigger: 'blur' }] }
    }
  },
  computed: {
    canCreateUser() { return this.can('system:user:add') && (this.currentUser.superAdmin || this.currentUser.accountType === 'MAIN') },
    hasRowActions() { return ['status', 'assign', 'reset', 'token', 'delete'].some(action => this.can('system:user:' + action)) },
    activeToken() { return this.tokenStatus[this.target.id] || {} }
  },
  async created() {
    try {
      this.currentUser = await getCurrentUser()
      await this.fetchUsers()
    } catch (error) { this.$message.error(error.msg || '读取账号信息失败') }
  },
  beforeDestroy() { this.requestId += 1; this.rolesRequestId += 1; this.detailRequestId += 1 },
  methods: {
    can(code) { return hasPermission(code) },
    isSelf(row) { return Boolean(row.id && String(row.id) === String(this.currentUser.id)) },
    isProtected(row) { return this.isSelf(row) || (!this.currentUser.superAdmin && row.accountType === 'MAIN') },
    accountLabel(user) { return user.realName ? `${user.realName}（${user.username}）` : user.username },
    mobileLabel(value) { return !value ? '-' : this.showMobile ? value : value.length > 7 ? value.slice(0, 3) + '****' + value.slice(-4) : '****' },
    formatDate(value) { return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-' },
    ttlLabel(seconds) { const hours = Math.floor(Number(seconds || 0) / 3600); return hours >= 24 ? `（剩余${Math.floor(hours / 24)}天）` : hours > 0 ? `（剩余${hours}小时）` : '（不足1小时）' },
    search() { this.pageNum = 1; this.fetchUsers() },
    resetQuery() { this.query = { username: '', realName: '', mobile: '', status: '' }; this.search() },
    changePage(page) { this.pageNum = page; this.fetchUsers() },
    changeSize(size) { this.pageSize = size; this.search() },
    async fetchUsers() {
      const id = ++this.requestId
      this.loading = true
      try {
        const response = await request.get('/webserver/users/page', { params: { ...this.query, pageNum: this.pageNum, pageSize: this.pageSize } })
        if (id !== this.requestId) return
        this.list = response.data.items
        this.total = Number(response.data.total)
        this.selection = []
        if (!this.list.length && this.total && this.pageNum > 1) { this.pageNum -= 1; await this.fetchUsers(); return }
        if (this.can('system:user:token')) await Promise.all(this.list.map(user => this.fetchTokenStatus(user.id, id)))
      } catch (error) { if (id === this.requestId) this.$message.error(error.msg || '读取用户失败') }
      finally { if (id === this.requestId) this.loading = false }
    },
    async loadMainAccounts() {
      if (!this.currentUser.superAdmin) { this.mainAccounts = [{ id: this.currentUser.ownerId, username: this.currentUser.accountType === 'MAIN' ? this.currentUser.username : `主账号 ${this.currentUser.ownerId}` }]; return }
      const response = await request.get('/webserver/users')
      this.mainAccounts = response.data.filter(user => user.accountType === 'MAIN')
    },
    async loadRoles(ownerId) {
      const id = ++this.rolesRequestId
      this.roles = []
      if (!ownerId) { this.rolesLoading = false; return }
      this.rolesLoading = true
      try {
        const roles = []
        let pageNum = 1
        let total = 0
        do {
          const response = await request.get('/webserver/system/roles', { params: { ownerId, pageNum, pageSize: 100, grantableOnly: true } })
          if (id !== this.rolesRequestId) return
          roles.push(...response.data.items)
          total = Number(response.data.total)
          pageNum += 1
        } while (roles.length < total)
        this.roles = roles
      } finally { if (id === this.rolesRequestId) this.rolesLoading = false }
    },
    async loadFormRoles() {
      this.form.roleIds = []
      if (!this.can('system:user:assign')) return
      try { await this.loadRoles(this.form.accountType === 'MAIN' ? this.editingId : this.form.parentUserId) }
      catch (error) { this.$message.error(error.msg || '读取角色失败') }
    },
    async openCreate() {
      if (!this.canCreateUser) return
      const id = ++this.detailRequestId
      this.editingId = null
      this.form = { ...newForm(), parentUserId: this.currentUser.ownerId }
      try {
        await this.loadMainAccounts()
        if (id !== this.detailRequestId) return
        this.dialogVisible = true
        this.$nextTick(() => this.$refs.userForm.clearValidate())
        await this.loadFormRoles()
      } catch (error) { if (id === this.detailRequestId) this.$message.error(error.msg || '读取主账号失败') }
    },
    async openEdit(row) {
      const id = ++this.detailRequestId
      try {
        const response = await request.get(`/webserver/users/${row.id}`)
        if (id !== this.detailRequestId) return
        await this.loadMainAccounts()
        if (id !== this.detailRequestId) return
        const user = response.data
        this.editingId = user.id
        this.form = { ...newForm(), ...user, password: '', roleIds: [...(user.roleIds || [])] }
        this.dialogVisible = true
        this.$nextTick(() => this.$refs.userForm.clearValidate())
        if (this.can('system:user:assign')) await this.loadRoles(user.accountType === 'MAIN' ? user.id : user.parentUserId)
      } catch (error) { if (id === this.detailRequestId) this.$message.error(error.msg || '读取用户失败') }
    },
    changeAccountType() { this.form.superAdmin = false; this.form.parentUserId = this.form.accountType === 'SUB' ? this.currentUser.ownerId : ''; this.loadFormRoles() },
    save() {
      this.$refs.userForm.validate(async valid => {
        if (!valid || this.saving || this.rolesLoading) return
        this.saving = true
        try {
          const payload = { username: this.form.username, realName: this.form.realName, mobile: this.form.mobile, email: this.form.email, remark: this.form.remark }
          if (!this.editingId) { payload.password = this.form.password; payload.accountType = this.form.accountType; payload.parentUserId = this.form.accountType === 'SUB' ? this.form.parentUserId : null }
          if (this.currentUser.superAdmin && !this.isSelf(this.form)) payload.superAdmin = this.form.superAdmin
          if (this.can('system:user:assign') && !this.isSelf(this.form) && (this.editingId || this.form.accountType === 'SUB')) payload.roleIds = this.form.roleIds
          if (this.editingId) await request.put(`/webserver/users/${this.editingId}`, payload)
          else await request.post('/webserver/users', payload)
          this.$message.success('保存成功')
          this.dialogVisible = false
          await this.fetchUsers()
        } catch (error) { this.$message.error(error.msg || '保存失败') }
        finally { this.saving = false }
      })
    },
    async openDetail(row) {
      const id = ++this.detailRequestId
      this.detail = { ...row }
      this.detailVisible = true
      this.detailLoading = true
      try {
        const response = await request.get(`/webserver/users/${row.id}`)
        if (id === this.detailRequestId) this.detail = response.data
      } catch (error) { if (id === this.detailRequestId) this.$message.error(error.msg || '读取详情失败') }
      finally { if (id === this.detailRequestId) this.detailLoading = false }
    },
    handleCommand(command, row) {
      if (command === 'status') this.changeStatus([row], row.status === 1 ? 0 : 1)
      if (command === 'delete') this.removeUsers([row])
      if (command === 'roles') this.openRoles(row)
      if (command === 'password') { this.target = row; this.passwordForm = { password: '' }; this.passwordVisible = true; this.$nextTick(() => this.$refs.passwordForm.clearValidate()) }
      if (command === 'token') { this.target = row; this.tokenVisible = true; this.refreshToken() }
    },
    canBatchStatus(status) { return this.selection.length > 0 && !this.selection.some(this.isProtected) && this.selection.some(row => row.status !== status) },
    async changeStatus(rows, status) {
      if (this.operating || !rows.length || rows.some(this.isProtected)) return
      try {
        await this.$confirm(`确认${status === 1 ? '启用' : '禁用'}选中的 ${rows.length} 个账号吗？`, '操作确认', { type: 'warning' })
        this.operating = true
        for (const row of rows.filter(item => item.status !== status)) await request.put(`/webserver/users/${row.id}/status`, { status })
        this.$message.success('状态已更新')
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || '状态更新失败，请刷新查看已完成的操作') }
      finally { if (this.operating) { this.operating = false; await this.fetchUsers() } }
    },
    async removeUsers(rows) {
      if (this.operating || !rows.length || rows.some(this.isProtected)) return
      try {
        await this.$confirm(`确认删除选中的 ${rows.length} 个账号吗？有关联数据的账号不能删除。`, '删除账号', { type: 'warning' })
        this.operating = true
        for (const row of rows) await request.delete(`/webserver/users/${row.id}`)
        this.$message.success('删除成功')
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || '删除失败，请刷新查看已完成的操作') }
      finally { if (this.operating) { this.operating = false; await this.fetchUsers() } }
    },
    async openRoles(row) {
      this.target = row
      this.assignedRoleIds = []
      this.roleVisible = true
      this.rolesLoading = true
      try {
        const response = await request.get(`/webserver/users/${row.id}`)
        if (!this.roleVisible || this.target.id !== row.id) return
        this.assignedRoleIds = response.data.roleIds || []
        await this.loadRoles(row.accountType === 'MAIN' ? row.id : row.parentUserId)
      } catch (error) { this.roleVisible = false; this.rolesLoading = false; this.$message.error(error.msg || '读取角色失败') }
    },
    async saveRoles() {
      if (this.saving || this.rolesLoading) return
      this.saving = true
      try { await request.put(`/webserver/users/${this.target.id}/roles`, { roleIds: this.assignedRoleIds }); this.$message.success('角色已更新'); this.roleVisible = false; await this.fetchUsers() }
      catch (error) { this.$message.error(error.msg || '分配角色失败') }
      finally { this.saving = false }
    },
    savePassword() {
      this.$refs.passwordForm.validate(async valid => {
        if (!valid || this.saving) return
        this.saving = true
        try { await request.put(`/webserver/users/${this.target.id}/password`, this.passwordForm); this.$message.success('密码已重置'); this.passwordVisible = false; await this.fetchUsers() }
        catch (error) { this.$message.error(error.msg || '重置密码失败') }
        finally { this.saving = false }
      })
    },
    async fetchTokenStatus(id, listRequestId) {
      try {
        const response = await request.get(`/webserver/users/${id}/api-token`)
        if (listRequestId === undefined || listRequestId === this.requestId) this.$set(this.tokenStatus, id, response.data)
      } catch (error) {
        if (listRequestId === undefined || listRequestId === this.requestId) this.$set(this.tokenStatus, id, { failed: true })
      }
    },
    async refreshToken() { this.tokenLoading = true; try { await this.fetchTokenStatus(this.target.id) } finally { this.tokenLoading = false } },
    async revokeToken() {
      if (this.operating) return
      try {
        await this.$confirm('撤销后该 API Token 将立即失效，是否继续？', '撤销 Token', { type: 'warning' })
        this.operating = true
        await request.delete(`/webserver/users/${this.target.id}/api-token`)
        this.$message.success('Token 已撤销')
        await this.refreshToken()
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.msg || '撤销失败') }
      finally { this.operating = false }
    },
    async exportUsers() {
      if (this.exporting) return
      this.exporting = true
      try {
        const response = await request.get('/webserver/users/export', { params: this.query, responseType: 'blob' })
        if (response.data.type.includes('json')) { const result = JSON.parse(await response.data.text()); throw new Error(result.msg || '导出失败') }
        saveAs(response.data, '用户列表.csv')
      } catch (error) { this.$message.error(error.msg || error.message || '导出失败') }
      finally { this.exporting = false }
    }
  }
}
</script>

<style src="./system-manage.css"></style>
